import { render, staticRenderFns } from "./ModalViewFileAttachment.vue?vue&type=template&id=5e3406f0&scoped=true&"
import script from "./ModalViewFileAttachment.vue?vue&type=script&lang=js&"
export * from "./ModalViewFileAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ModalViewFileAttachment.vue?vue&type=style&index=0&id=5e3406f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3406f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VDialog,VIcon})
